export default __webpack_public_path__ + "static/media/terminal.a5b92a18.svg";